import './styles.scss';
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import { Fade } from 'react-awesome-reveal';
import $ from 'jquery';
import { SkeletonBlogItem } from '../../components/comment/SkeletonBlogItem';
import { removeBaseUrl } from '../../utils';

const Single = () => {
    const { slug } = useParams();
    const [isFetching, setIsFetching] = useState(true);
    const [postContent, setPostContent] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "Wood Edwards";
        fetchPostContent(slug);

        return (() => {})
    }, [slug]);

    const fetchPostContent = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_post_by_slug&slug=${slug}`);
            setPostContent(data ?? null);
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                if (data?.post) {
                    document.title = data?.post?.post_title;
                }
            }

            const postId = data?.post?.ID;
            if (document.querySelector('#wp-admin-bar-edit a') && postId) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Post`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${postId}&action=edit`;
            }

            setTimeout(() => {
                $("#table-of-contents").html("");
                var toc = $("#table-of-contents");
                var lastLevel = 2; // Assuming the first heading level is H2
            
                $("article h2, article h3").each(function(index) {
                    var heading = $(this);
                    var headingText = heading.text();

                    var anchor = headingText.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/\s+/g, '-').toLowerCase();
                    heading.attr('id', anchor);
                    var level = parseInt(this.tagName.substring(1));
                    
                    if (level > lastLevel) {
                        // Start a new sublist
                        var sublist = $("<ul>");
                        toc.find('li:last').append(sublist);
                        toc = sublist;
                    } else if (level < lastLevel) {
                        // End current sublist(s)
                        toc = toc.parents('ul').last();
                    }
                    
                    lastLevel = level;
                    if (anchor?.length > 1) {
                        var listItem = $('<li>').appendTo(toc);
                        listItem.append($('<a>').attr('href', '#' + anchor).text(headingText));
                    }
                });

                $('#table-of-contents a').on('click', function (e) {
                    let elementId = $(this).attr('href');

                    var elementTop = $(elementId).offset()?.top ?? 0;
                    var viewportHeight = $(window).height();
                    var newScrollTop = elementTop - (viewportHeight / 2);
                  
                    window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
                    e.stopPropagation();
                    return false;
                  });
            }, 600);

            window.addEventListener('scroll', highlightActiveItem);

        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    const formatDate = (v) => {
        const today = new Date(v);
        const month = today.getMonth() + 1;
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
        const day = today.getDate();
        const formattedDay = day < 10 ? `0${day}` : `${day}`;
        const year = today.getFullYear();
        const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;
        return formattedDate;
    }


    const generateRandomWidth = () => {
        // Generate a random width between 50% and 100%
        return `${Math.floor(Math.random() * 51) + 50}%`;
    };

    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const highlightActiveItem = () => {
        var headings = $("h2, h3");
        var tocLinks = $("#table-of-contents a");
        
        headings.each(function(index) {
            if (isElementInViewport(this)) {
                tocLinks.removeClass("active");
                var currentAnchor = $(this).attr("id");
                tocLinks.filter("[href='#" + currentAnchor + "']").addClass("active");
            }
        });
    }



    return <Fade delay={1}>
        <div className='single-blog-page'>
            <section id="banner" className='single-blog-banner'>
                <div className='inner-wrapper'>
                    <div className='banner-area'>
                        {!isFetching && <h1>{postContent?.post?.post_title}</h1>}
                        {isFetching && <h1><Skeleton width={"100%"} /></h1>}
                        {!isFetching && <div className='blog-meta'>
                            <div className='blog-meta-left'>
                                <span className='author'>By {postContent?.author?.data?.display_name ?? ""}</span>
                                <span className='date'><label>Updated: </label>{formatDate(postContent?.post?.post_date)}</span>
                            </div>
                            <div className='blog-categories'>
                                {
                                    postContent?.categories?.map((it, index) => {
                                        return <a className='tag' href={`/category/articles/${it.slug}/`} key={index}>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#037C8E"/>
                                                </svg>
                                                {it?.name}
                                            </a>
                                    })
                                }
                            </div>
                        </div>}
                        {isFetching && <div className='blog-meta'>
                            <div className='blog-meta-left'>
                                <span className='author'>By <Skeleton width="100px" /></span>
                                <span className='date'><label>Updated: </label><Skeleton width="120px" /></span>
                            </div>
                            <div className='blog-categories'>
                                {
                                    [1].map((it, index) => {
                                        return <span className='tag' key={index}>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#037C8E"/>
                                                </svg>
                                                <Skeleton width="100px" />
                                            </span>
                                    })
                                }
                            </div>
                        </div>}
                    </div>
                </div>
            </section>

            <section id="single-blog-details-container">
                <div className='single-blog-sidebar-wrapper'>
                    <div className='main-content'>
                        {!isFetching && <article dangerouslySetInnerHTML={{__html: postContent?.post?.post_content}}></article>}
                        {
                            isFetching && <article>
                                {Array.from({length: 30}).map(it => <Skeleton width={generateRandomWidth()} height="20px" key={it} style={{marginTop: "5px"}} />)}
                            </article>
                        }
                        {
                            postContent?.attorney && <div className='attorney-box'>
                                <div className='block-photo'>
                                    <img src={postContent?.attorney?.head_shot} />
                                </div>
                                <div className='block-details'>
                                    <span className='title'>Meet the Attorney</span>
                                    <span className='name'>{postContent?.attorney?.name}</span>
                                    <div className='details' dangerouslySetInnerHTML={{__html: postContent?.attorney?.bio_content}}></div>
                                    <div className='block-links'>
                                        <Link to={postContent?.attorney?.bio_url}>View Bio</Link>
                                        {postContent?.attorney?.phone_number && <a href={`tel:${postContent?.attorney?.phone_number}`}>{postContent?.attorney?.phone_number}</a>}
                                        {postContent?.attorney?.email && <a href={`mailto:${postContent?.attorney?.email}`}>{postContent?.attorney?.email}</a>}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <aside className={`sidebar ${postContent?.featured_image ? "has-featured-image" : ""}`}>
                        {!isFetching && postContent?.featured_image && <div className='featured-image' dangerouslySetInnerHTML={{__html: postContent?.featured_image}}>
                        </div>}
                        {
                            isFetching && <div className='featured-image'>
                                <Skeleton width="100%" height="300px" />
                            </div>
                        }
                        {!isFetching && <div className='toc-wrapper'>
                            <span className='title'>Page Contents</span>
                            <ul id="table-of-contents">
                                
                            </ul> 
                        </div>}
                        {
                        isFetching && <div className='toc-wrapper'>
                            <span className='title'><Skeleton width="100%" /></span>
                            <ul id="table-of-contents">
                            {Array.from({length: 5}).map(it => <Skeleton width={generateRandomWidth()} height="20px" key={it} style={{marginTop: "5px"}} />)}</ul> 
                        </div>
                        }
                    </aside>
                </div>
            </section>

            <section id="posted-articles-section">
                <div className='inner-wrapper'>
                    <div id="section-header">
                        <h2>Related Articles</h2>
                        <Link to={"/articles/"} className='button'>Browse All Articles</Link>
                    </div>

                    <div className="posts-wrapper">
                        <div className='posts-repeater'>
                            {
                                !isFetching && postContent?.related_articles?.map((it, index) => {
                                    return <div className='blog-item' key={index}>
                                        <Link to={removeBaseUrl(it?.permalink)} className='blog-title'>
                                            {it?.post?.post_title ?? ""}
                                        </Link>
                                        <div className='blog-meta'>
                                            <span className='author'>By {it?.author?.data?.display_name ?? "Unknown"}</span>
                                            <span className='category'>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#024953"/>
                                                </svg>
                                                {it?.cats?.length > 0 ? it?.cats[0].name : "Not specified"}
                                            </span>
                                        </div>
                                        <span className='excerpt'>
                                            {it?.excerpt?.length > 100 ? `${it?.excerpt?.substring(0, 100)}...` : it.excerpt} <Link to={removeBaseUrl(it?.permalink)}>Read more</Link>
                                        </span>
                                    </div>
                                })
                            }
                            {
                                isFetching && [1, 2, 3].map((it) => {
                                    return <SkeletonBlogItem key={it} />
                                })
                            }
                        </div>
                    </div>

                </div>
            </section>
        </div>
    </Fade>
}

export default Single;